import * as React from "react";
import { SVGProps } from "react";
const SvgGift1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 1a4 4 0 0 1 3.464 6H27a1 1 0 0 1 1 1v9a1 1 0 0 1 .117 1.993L28 19v9a1 1 0 0 1-1 1H17a1 1 0 0 1-1.993.117L15 29H5a1 1 0 0 1-1-1v-9a1 1 0 0 1-.117-1.993L4 17V8a1 1 0 0 1 1-1h.534a4 4 0 0 1 6.094-5.015l4.371 3.816 4.372-3.815a3.98 3.98 0 0 1 2.385-.979L23 1Zm-8 18H6v8h9v-8Zm11 0h-9v8h9v-8Zm0-10h-9v8h9V9ZM15 9H6v8h9V9Zm8-6c-.491 0-.952.176-1.314.492L17.666 7H23a2 2 0 0 0 1.995-1.85L25 5a2 2 0 0 0-2-2ZM8.998 3a2 2 0 0 0-2 2l.005.15A2 2 0 0 0 8.998 7h5.334l-4.02-3.508A1.984 1.984 0 0 0 8.998 3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGift1;
